import { Box, Typography } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { useOperationAreaColumns } from "../model/operationAreaColumns";
import { mockOperationAreaRows } from "../model/operationAreaRows";
import { useTranslate } from "src/locales";

const OperationAreaSection = () => {
    const { t } = useTranslate();
    const operationAreaColumns = useOperationAreaColumns();
    return (
        <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2 }}>
            <Box sx={{ backgroundColor: "#63B4FF33", borderRadius: "8px", p: 1, mb: 2 }}>
                <Typography fontWeight={600} color="#2979C3">
                    {t('safety-surgery.opearation-area-verification-and-marking')}
                </Typography>
            </Box>
            <ByzMuiDataGrid
                rows={mockOperationAreaRows}
                columns={operationAreaColumns}
                pageSize={5}
            />
        </Box>
    );
};

export default OperationAreaSection;